<template>
  <div id="DetalleDeDocumento_div" class="w-0 px-0 py-0">
    <div id="TituloDetalleDeDocumento_div">
      <h5 class="label-black" style="margin-bottom: 0px;">REPORTES</h5>
      <h6 class="label-black" style="margin-top: 0px;">Reporte del Historial de movimientos de los documentos</h6>
    </div>
    <div class="row d-flex">
      <div class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low">
        <div class="area custom-area">
          <div class="form-group" id="codigo_div">
            <label class="label-black">Documento:</label>
            <input class="form-control" type="text" placeholder="Código de Barras" v-model="Busqueda.CodigoBarras" v-on:keyup.enter= 'DetectarEnter' />
          </div>
          <div id="BotonBusqueda_div" class="text-right">
            <button class="btn btn-sm btn-custom" @click='ObtenerDocumento()'>Obtener Historial</button>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low" v-if="this.MostrarResultado">
        <div class="area custom-area">
          <div>
            <h6 class="label-black">Datos del Documento</h6>
            <hr />
          </div>
          <div class="row align-items-center">
            <div class="form-group col-8" id="Area_div">
              <label class="label-black">Área</label>
              <input type="text" class="form-control" v-model="DocumentoObtenido.Area.Nombre" readonly />
            </div>
            <div class="form-group col-4" id="Materia_div">
              <label class="label-black">Materia</label>
              <div v-if="DocumentoObtenido.Materia != null">
                <input type="text" class="form-control" v-model="DocumentoObtenido.Materia.Nombre" readonly />
              </div>
              <div v-else>
                <input type="text" class="form-control" readonly />
              </div>
            </div>
          </div>
          <div class="row align-items-center">
            <div class="form-group col-4" id="TipoDocumento_div">
              <label class="label-black">Tipo de Documento</label>
              <input type="text" class="form-control" v-model="DocumentoObtenido.TipoDocumento.Nombre" readonly />
            </div>
            <!-- <div class="form-group col-4" id="Anio_div">
              <label class="label-black">Año</label>

              <input type="text" class="form-control " v-model="DocumentoObtenido.Anio" readonly />
            </div> -->
            <div class="form-group col-4" id="Consecutivo_div">
              <label class="label-black">Consecutivo</label>
              <input type="text" class="form-control" v-model="consecutivo" readonly />
            </div>
            <div class="form-group col-4" id="Anio_div" v-if="AreaConsulta.Area.AreaId!=21">
              <label class="label-black">Registro en Archivo</label>
              <input type="text" class="form-control " v-model="DocumentoObtenido.FechaRegistroArchivo" readonly/>
            </div>
            <div class="form-group col-2" id="Anio_div" v-if="AreaConsulta.Area.AreaId==21 && DocumentoObtenido.FechaRegistroArchivo!=null">
              <label class="label-black">Registro en Archivo</label>
              <input type="text" class="form-control " v-model="DocumentoObtenido.FechaRegistroArchivo" readonly/>
            </div>
            <div class="form-group col-2 align-self-end" id="btn_Actualizar" v-if="AreaConsulta.Area.AreaId==21 && DocumentoObtenido.FechaRegistroArchivo!=null">
              <button class="btn btn-sm btn-warning" @click='EliminarFecha(DocumentoObtenido)' title="Elimina la fecha de registro en el Archivo">Eliminar Fecha</button>
            </div>
            <div class="form-group col-2" id="Anio_div" v-if="AreaConsulta.Area.AreaId==21 && DocumentoObtenido.FechaRegistroArchivo==null">
              <label class="label-black">Registro en Archivo</label>
              <input type="date" class="form-control " v-model="FechaRegistro" />
            </div>
            <div class="form-group col-2 align-self-end" id="btn_Actualizar" v-if="AreaConsulta.Area.AreaId==21 && DocumentoObtenido.FechaRegistroArchivo==null">
              <button class="btn btn-sm btn-warning" @click='ActualizarFecha(DocumentoObtenido)' title="Actualiza la fecha de registro en el Archivo">Actualizar Fecha</button>
            </div>
          </div>
          <div class="row align-items-center" v-if="AreaConsulta.Area.AreaId==21">
            <div class="form-group col-4" id="referecia_div">
              <label class="label-black">Referecia de Base de Datos</label>
              <input type="text" class="form-control" v-model="DocumentoObtenido.DocumentoId_Referencia" />
            </div>
            <div class="form-group col-2 align-self-end" id="referecia_div">
              <button class="btn btn-sm btn-warning" @click='ActualizarReferencia(DocumentoObtenido)' title="Actualiza la referencia del documento origen">Actualizar Referencia</button>
            </div>
          </div>
          <br>
          <div v-if="DocumentoObtenido.SolicitudActualTramite!=null">
            <h6 class="text-warning text-center">Documento con Solicitud de Prestamo en Tramite en {{this.obtenFecha(DocumentoObtenido.SolicitudActualTramite.FechaRegistro)}}</h6>
          </div>
          <div v-if="pendientesRecepcion.length>0">
              <h6 class="text-warning text-center">Pendiente de Recepción</h6>
              <ul class="text-warning text-center">
                <li v-for="item in pendientesRecepcion">
                  <span>{{item.elemento}} ,&nbsp;Origen: &nbsp;{{item.areaQuePresta}},&nbsp; Destino: &nbsp;{{item.areaQueRecibe}}, &nbsp;enviado en : &nbsp;{{item.fechaEnvio}}
                  </span>
                </li>
              </ul>
              <h6 class="text-danger text-center">ver detalles de movimientos</h6>
          </div>
          <br v-if="DocumentoObtenido.SolicitudActualTramite!=null">
        </div>
      </div>
    </div>
    <div class="row d-flex" v-if="MostrarResultado">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 padding-div-low">
        <div class="area custom-area">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" >
              <a class="nav-link active" id="home-tab" data-toggle="tab" href="#Movimientos" role="tab" aria-controls="Movimientos" aria-selected="true"><b class="text-warning">Movimientos</b></a>
            </li>
            <li class="nav-item" v-if="Solicitudes.length>0">
              <a class="nav-link" id="profile-tab" data-toggle="tab" href="#Solicitudes" role="tab" aria-controls="Solicitudes Nuevo Sistema" aria-selected="false"><b class="text-warning">Solicitudes al Archivo</b></a>
            </li>
            <li class="nav-item" v-if="ListadosArchivo.length>0">
              <a class="nav-link" id="profile-tab" data-toggle="tab" href="#Listados" role="tab" aria-controls="Listados Nuevo Sistema" aria-selected="false"><b class="text-warning">Listados de Archivo</b></a>
            </li>
            <li class="nav-item" v-if="Archivatec.length>0">
              <a class="nav-link" id="profile-tab" data-toggle="tab" href="#Archivatec" role="tab" aria-controls="Archivatec" aria-selected="false"><b class="text-primary">Movimientos Archivatec Anterior</b></a>
            </li>
            <li class="nav-item" v-if="ListadosAnteriores.length>0 && AreaConsulta.Area.AreaId==21">
              <a class="nav-link" id="profile-tab" data-toggle="tab" href="#Anteriores" role="tab" aria-controls="Anteriores" aria-selected="false"><b class="text-primary">Listados Archivatec Anterior</b></a>
            </li>
            <li class="nav-item" v-if="PublicoAnteriores.length>0 && AreaConsulta.Area.AreaId==21">
              <a class="nav-link" id="profile-tab" data-toggle="tab" href="#PublicoAnteriores" role="tab" aria-controls="PublicoAnteriores" aria-selected="false"><b class="text-primary">Solicitudes Publicas Archivatec Anterior</b></a>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="Movimientos" role="tabpanel" aria-labelledby="home-tab" >
              <div id="Volumen_table" class="table-reponsive" v-if="DocumentoObtenido.Volumenes.length > 0">
                <table class="table table-striped table-light table-hover table-sm">
                  <thead class="thead-custom">
                    <tr>
                      <th>Elemento</th>
                      <th>Ubicación Actual</th>
                      <th class="text-center"></th>
                    </tr>
                  </thead>
                  <tbody class="text-dark">
                    <tr  v-for="detalle in ListadoElementos">
                      <td width="150">{{detalle.TipoDescripsion}} No {{detalle.Tomo}}</td>
                      <td>{{detalle.Ubicacion}}</td>
                      <td class="text-center">
                        <a class="button button-secondary text-center" v-on:click="VerDetalle(detalle)" title="Muestra los detalles de Movimientos" v-if="MovimientosDocumentos.length>0">
                          <i class="fas fa-eye">  Ver Detalles en Sistema Actual</i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-if="MovimientosFiltrados.length>0">
                <h6 class="label-black">{{Etiqueta}}</h6>
              </div>
              <div v-if="MovimientosFiltrados.length>0">
                <div id="Movimientos_table" class="table-responsive" >
                  <table class="table table-striped table-light table-hover table-sm">
                    <thead class="thead-custom">
                      <tr>
                        <th>Fecha de Movimiento</th>
                        <th>Origen</th>
                        <th>Destino</th>
                        <th>Fecha de Recepción</th>
                        <th>Observaciones</th>
                        <th>Realizado por:</th>
                        <th></th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody class="text-dark">
                      <tr v-for="(Listado, index) in MovimientosFiltrados" :key="Listado.MovimientoDocumentoId">
                        <td width ="100" v-html="obtenFechaConFormato(Listado.FechaMovimiento)" style="width: 100px;"></td>
                        <td width ="250" v-html='ObtenerDatosOrigen(Listado)'> </td>
                        <td width ="250" v-html='ObtenerDatosDestino(Listado)'></td>
                        <td width ="100" v-if="Listado.FechaRecepcion!= null" v-html="obtenFechaConFormato(Listado.FechaRecepcion)" style="width: 100px;"></td>
                        <td width ="100" v-else>
                          <span class="badge badge-pill badge-danger text-center">PENDIENTE</span>
                        </td>
                        <td width ="300" v-html="ObservacionesParaExternos(Listado)"></td>
                        <!-- <td width ="300" v-if="Listado.AreaExterna==null">{{Listado.Observaciones}}</td>
                        <td width ="300" v-else v-html="DetallesExternos(Listado)"></td> -->
                        <td width ="250">{{Listado.UsuarioQuienRegistra!=null ? Listado.UsuarioQuienRegistra.Nombre : ''}} {{Listado.UsuarioQuienRegistra!=null ? Listado.UsuarioQuienRegistra.ApellidoPaterno : ''}} {{Listado.UsuarioQuienRegistra!=null ? Listado.UsuarioQuienRegistra.ApellidoMaterno : ''}}
                        </td>
                        <td width ="30" v-if="Listado.AreaExterna!=null && Listado.AreaExterna.AreaExternaId!=null && Listado.FechaRecepcion==null && AreaConsulta.Area.AreaId!=21 ">
                            <a  v-on:click="EditarDetallesExternos(Listado)" title="Editar detalles de Área Externa">
                              <i class="fas fa-pen-square"></i>
                            </a>
                        </td>
                        <td v-else width="30"></td>
                        <td width ="30" v-if="AreaConsulta.Area.AreaId==21 && ObtieneDatosConSolicitudes(index, Listado)==true">
                          <a  v-on:click="EliminarMovimiento(Listado)" title="Eliminar Movimiento">
                              <i class="fas fa-minus-circle"></i>
                            </a>
                        </td>
                        <td v-else width="30"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="Archivatec" role="tabpanel" aria-labelledby="home-tab" v-if="Archivatec.length>0">
              <div id="Archivatec_table" class="table-responsive">
                <table class="table table-striped table-light table-hover table-sm">
                  <thead class="thead-custom">
                    <tr>
                      <th>Área que Presta</th>
                      <th>Ubicación</th>
                      <th>Área que Recibe</th>
                      <th>Ubicación</th>
                      <th>Fecha de Prestamo</th>
                      <th>Fecha de Devolución</th>
                    </tr>
                  </thead>
                  <tbody class="text-dark">
                    <tr v-for="lista in Archivatec" :key="lista.IdPrestamo">
                      <td>{{lista.AreaPresta.Nombre}}</td>
                      <td v-html="ObtenUbicacion(lista.Prestador)"></td>
                      <td>{{lista.AreaRecibe.Nombre}}</td>
                      <td v-html="ObtenUbicacion(lista.Receptor, lista.Notaria)"></td>
                      <td v-html="obtenFechaArchivatec(lista.FechaPrestamo)"></td>
                      <td v-html="obtenFechaArchivatec(lista.FechaRegreso)"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="tab-pane fade" id="Anteriores" role="tabpanel" aria-labelledby="home-tab" v-if="ListadosAnteriores.length>0 && AreaConsulta.Area.AreaId==21">
              <div id="Anteriores_table" class="table-responsive">
                <table class="table table-striped table-light table-hover">
                  <thead class="thead-custom">
                    <tr>
                      <th>Fecha</th>
                      <th>Tipo</th>
                    </tr>
                  </thead>
                  <tbody class="text-dark">
                    <tr v-for="lista in ListadosAnteriores">
                      <td v-html="obtenFechaArchivatec(lista.Fecha)"></td>
                      <td v-if="lista.tipo==1" class="text-success">Nuevo Ingreso</td>
                      <td v-else class="text-primary">Reingreso</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="tab-pane fade" id="PublicoAnteriores" role="tabpanel" aria-labelledby="home-tab" v-if="PublicoAnteriores.length>0 && AreaConsulta.Area.AreaId==21">
              <div id="Publicos_table" class="table-responsive">
                <table class="table table-striped table-light table-hover">
                  <thead class="thead-custom">
                    <tr>
                      <th>Fecha de Solicitud</th>
                      <th>Solicitado por:</th>
                    </tr>
                  </thead>
                  <tbody class="text-dark">
                    <tr v-for="lista in PublicoAnteriores">
                      <td v-html="obtenFechaArchivatec(lista.fechaPrestamos)"></td>
                      <td >{{lista.Nombre.toUpperCase()}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="tab-pane fade" id="Solicitudes" role="tabpanel" aria-labelledby="home-tab" v-if="Solicitudes.length>0">
              <div id="Solicitudes_table" class="table-responsive">
                <table class="table table-striped table-light table-hover table-sm">
                  <thead class="thead-custom">
                    <tr>
                      <th>Fecha de Solicitud</th>
                      <th>Tipo Solicitud</th>
                      <th>Estatus</th>
                      <th>Solicitado por:</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody class="text-dark">
                    <tr v-for="lista in Solicitudes" :key="lista.SolicitudDocumentoId">
                      <td v-html="obtenFecha(lista.FechaRegistro)"></td>
                      <td v-if="lista.SolicitudJuzgadoId!=null">Solicitud de Juzgado</td>
                      <td v-else>Solicitud Pública</td>
                      <td v-if="lista.TipoEstatusSolicitud.TipoEstatusSolicitudDocumentoId==1">
                        <h6 class="label-black"><span class="badge badge-pill badge-primary text-center">{{lista.TipoEstatusSolicitud.Nombre}}</span></h6>
                      </td>
                      <td v-if="lista.TipoEstatusSolicitud.TipoEstatusSolicitudDocumentoId==2">
                        <h6 class="label-black"><span class="badge badge-pill badge-info text-center">{{lista.TipoEstatusSolicitud.Nombre}}</span></h6>
                      </td>
                      <td v-if="lista.TipoEstatusSolicitud.TipoEstatusSolicitudDocumentoId==3">
                        <h6 class="label-black"><span class="badge badge-pill badge-warning text-center">{{lista.TipoEstatusSolicitud.Nombre}}</span></h6>
                      </td>
                      <td v-if="lista.TipoEstatusSolicitud.TipoEstatusSolicitudDocumentoId==4">
                        <h6 class="label-black"><span class="badge badge-pill badge-success text-center">{{lista.TipoEstatusSolicitud.Nombre}}</span></h6>
                      </td>
                      <td v-if="lista.TipoEstatusSolicitud.TipoEstatusSolicitudDocumentoId==5">
                        <h6 class="label-black"><span class="badge badge-pill badge-danger text-center">{{lista.TipoEstatusSolicitud.Nombre}}</span></h6>
                      </td>
                      <td v-html="UsuariosSolicitud(lista)"></td>
                      <td width ="30" v-if="AreaConsulta.Area.AreaId==21 && lista.SolicitudPublicaId!=null">
                        <a  v-on:click="EliminarSolicitud(lista)" title="Eliminar Solicitud">
                          <i class="fas fa-minus-circle"></i>
                        </a>
                      </td>
                      <td v-else width="30"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="tab-pane fade" id="Listados" role="tabpanel" aria-labelledby="home-tab" v-if="ListadosArchivo.length>0">
              <div id="Listados_table" class="table-responsive">
                <table class="table table-striped table-light table-hover table-sm">
                  <thead class="thead-custom">
                    <tr>
                      <th>Fecha de Envio</th>
                      <th>Tipo</th>
                      <th>Estatus</th>
                      <th>Enviado por:</th>
                      <!-- <th></th> -->
                    </tr>
                  </thead>
                  <tbody class="text-dark">
                    <tr v-for="lista in ListadosArchivo" :key="lista.ListadoArchivoId">
                      <td v-html="obtenFecha(lista.FechaEnvio)"></td>
                      <td v-if="lista.Devolucion==false">Nuevo Ingreso</td>
                      <td v-else>Reingreso</td>
                      <td v-if="lista.Enviado==false"><h6 class="label-black"><span class="badge badge-danger">PENDIENTE</span></h6></td>
                      <td v-else><h6 class="label-black"><span class="badge badge-success">ENVIADO</span></h6></td>
                      <td>{{lista.Usuario.Nombre}} {{lista.Usuario.ApellidoPaterno}} {{lista.Usuario.ApellidoMaterno}}</td>
                      <!-- <td width ="30" v-if="AreaConsulta.Area.AreaId==21 && lista.Enviado==true">
                        <a  v-on:click="EliminarListado(lista)" title="Eliminar de Listado de Archivo">
                          <i class="fas fa-minus-circle"></i>
                        </a>
                      </td>
                      <td v-else width="30"></td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        
        
      </div>
    </div>
    <div v-if="MostrarModal==true">
      <DetallesExt :movimiento = this.DatosExternos @dialogo='EstatusModal($event)'></DetallesExt>
    </div>
  </div>
    
</template>

<script>
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'
import FiltroDeBusqueda from '@/components/ArchivoJudicial/Comun/ConsultaDocumento.vue'
import modalDetalles from '@/components/ArchivoJudicial/Comun/EditExternos.vue'

export default {
     components:{
        Busqueda: FiltroDeBusqueda,
        DetallesExt: modalDetalles
    },
    data(){
        return{
            Busqueda: {
                CodigoBarras: "",
            },
            MovimientosDocumentos: [],
            MostrarTabla: false,
            MostrarArchivatec: false,
            MostrarResultado: false,
            DocumentoObtenido: {
                InventarioDocumentoId: "",
                Area: {},
                Materia: {},
                TipoDocumento: {},
                Año: "",
                Consecutivo: "",
                TipoEstatusInventario: {},
                Volumenes :[],
            },
            consecutivo: "",
            MovimientosFiltrados: [],
            Etiqueta: "",
            AreaConsulta: {},
            Archivatec : [],
            MostrarModal :false,
            DatosExternos :{
              AreaExterna : {},
              DetallesExternos : {}
            },
            Solicitudes : [],
            ListadosAnteriores : [],
            ListadosArchivo: [],
            PublicoAnteriores :[],
            ListadoElementos: [],
            FechaRegistro: "",
            pendientesRecepcion: [],
            messagePendientes: ''

        }
    },
    methods: {
      obtenFecha(fecha)
      {
        return moment(fecha).format("DD-MM-YYYY");
      },
      ValidarDatos(){
           
            if(this.Busqueda.CodigoBarras =="" || this.Busqueda.CodigoBarras == null)
            { comun.mensajeDeAlerta("Indicar el código del Documento.", null, null);
                return false;
            }
            else
            {
              var Resultado = this.ChecaCodigo(this.Busqueda.CodigoBarras);
                if(Resultado.Estatus!=true)
                {
                    comun.mensajeDeAlerta(Resultado.Mensaje, null, null);
                    this.Busqueda.CodigoBarras="";
                    return false;
                }
            }
            return true;
      },
      ObtenerHistorial: function(){
            $('#navMovimientos_table').remove();
            $('#navArchivatec_table').remove();
            $('#navListados_table').remove();
            $('#navSolicitudes_table').remove();
            $('#navAnteriores_table').remove();
            $('#navPublicos_table').remove();
                this.MostrarTabla = false;
                this.MostrarArchivatec = false;
                this.Archivatec = [];
                this.MovimientosDocumentos = [];
                this.Solicitudes =[];
                this.ListadosArchivo = [];
                this.ListadosAnteriores = [];
                var peticion = {
                    "CodigoBarras": this.Busqueda.CodigoBarras,
                    "FechaInicial": this.Busqueda.fechaInicial,
                    "FechaFinal": this.Busqueda.fechaFinal
                    };
                comun.SeEstaCargandoInformacion(true);
                axios.post(api.conexion + api.ArchivoJudicial.HistoricosDeMovimientos, peticion,
                comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                    .then( respuesta => {
                        if(respuesta.data.SiHayError)
                        {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(respuesta);
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        }
                        else
                        {
                            this.MovimientosDocumentos = respuesta.data.ListaMovimientos != null ? respuesta.data.ListaMovimientos : [];
                            this.Archivatec = respuesta.data.ListaArchivatec;
                            this.Solicitudes = respuesta.data.Solicitudes;
                            this.ListadosArchivo = respuesta.data.ListadosArchivo;
                            this.ListadosAnteriores = respuesta.data.ListadoAnterior;
                            this.PublicoAnteriores = respuesta.data.PrestamosPublicos;
                            if(this.Solicitudes.length>0)
                            {
                              this.$nextTick(()=> { PaginarTabla('Solicitudes_table', 5)});
                            };
                            if(this.ListadosAnteriores.length>0)
                            {
                              this.$nextTick(()=> { PaginarTabla('Anteriores_table', 5)});
                            };
                            if(this.ListadosArchivo.length>0)
                            {
                              this.$nextTick(()=> { PaginarTabla('Listados_table', 5)});
                            };
                            if(this.Archivatec.length>0)
                            {
                              this.$nextTick(()=> { PaginarTabla('Archivatec_table', 5)});
                            }
                            if(this.PublicoAnteriores.length>0)
                            {
                              this.$nextTick(()=> { PaginarTabla('Publicos_table', 5)});
                            }
                            comun.SeEstaCargandoInformacion(false);
                            if(this.MovimientosDocumentos.length== 0 || this.MovimientosDocumentos == null)
                            {
                              comun.mensajeDeAlerta("Sin Movimientos en este Periodo", null, null);
                            }
                            this.checkRecepcion(this.DocumentoObtenido);
                        }
                        comun.SeEstaCargandoInformacion(false);
                        })
                        .catch(excepcion => {
                            console.log(excepcion);
                            console.log("fallo por parametros");
                            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                            comun.SeEstaCargandoInformacion(false);
                        })

      },
      obtenFechaConFormato: function(fechaRegistro) {
        return moment(fechaRegistro).format("DD-MM-YYYY <br/> h:mm a");
      },
      obtenFechaArchivatec: function(fechaRegistro) {
        if(fechaRegistro!=null)
        {
          return moment(fechaRegistro).format("DD-MM-YYYY");
        }
        else
        {
          return '';
        }
      },
      ObtenerDocumento : async function(){
        this.pendientesRecepcion =[];
        this.FechaRegistro = "";
        this.ListadoElementos = [];
        this.MostrarResultado = false;
        this.MostrarTabla =false;
        this.DocumentoObtenido={};
        this.MovimientosDocumentos = [];
        this.Archivatec = [];
        this.MovimientosFiltrados = [];
        this.PublicoAnteriores=[];
        this.ListadosAnteriores=[];
            if(this.ValidarDatos())
            {
                var peticion = {
                    "AreaId": -1,
                    "TipoDocumentoId" : -1,
                    "Anio" : null,
                    "Consecutivo": null,
                    "Sufijo": null,
                    "CodigoBarras": this.Busqueda.CodigoBarras,
                };

                comun.SeEstaCargandoInformacion(true);
                axios.post(api.conexion + api.ArchivoJudicial.ObtenerDocumento, peticion,
                comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                .then( respuesta => {
                    if(respuesta.data.SiHayError)
                    {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(respuesta);
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    }
                    else
                    {
                        this.DocumentoObtenido = respuesta.data.GetDocumento;
                        this.DocumentoObtenido.FechaRegistroArchivo = respuesta.data.GetDocumento.FechaRegistroArchivo!=null? moment(respuesta.data.GetDocumento.FechaRegistroArchivo).format("DD/MM/YYYY"):null;
                        this.consecutivo= this.DocumentoObtenido.Consecutivo + "/" + this.DocumentoObtenido.Anio;
                        if(this.DocumentoObtenido.Volumenes.length>0)
                        {
                          this.DocumentoObtenido.Volumenes.forEach((element)=>{
                            this.ListadoElementos.push({
                              "Tipo" : 1,
                              "TipoDescripsion" : "Tomo",
                              "ElementoId" : element.VolumenId,
                              "Tomo": element.NumVolumen,
                              "Ubicacion" : this.getUbicacionToTable(element, null, null)
                            })
                          });
                        };
                        if(this.DocumentoObtenido.Tercerias.length>0)
                        {
                          this.DocumentoObtenido.Tercerias.forEach((element)=>{
                            this.ListadoElementos.push({
                              "Tipo" : 2,
                              "TipoDescripsion" : "Terceria",
                              "ElementoId" : element.TerceriaId,
                              "Tomo": element.NumeroTerceria,
                              "Ubicacion" : this.getUbicacionToTable(null, null, element)
                            })
                          });
                        };
                        if(this.DocumentoObtenido.Incidentes.length>0)
                        {
                          this.DocumentoObtenido.Incidentes.forEach((element)=>{
                            this.ListadoElementos.push({
                              "Tipo" : 3,
                              "TipoDescripsion" : "Incidente",
                              "ElementoId" : element.IncidenteId,
                              "Tomo": element.NumeroIncidente,
                              "Ubicacion" : this.getUbicacionToTable(null, element, null)
                            })
                          });
                        };
                        switch(this.AreaConsulta.Area.AreaId)
                        {
                          case 21:
                            //this.DocumentoObtenido = respuesta.data.GetDocumento;
                            this.ObtenerHistorial();
                            this.MostrarResultado=true;
                            this.MostrarTabla=false;
                            this.MovimientosFiltrado = [];
                            
                            break;
                          default:
                            if(this.AreaConsulta.Area.AreaId==respuesta.data.GetDocumento.Area.AreaId)
                              {
                                //this.DocumentoObtenido = respuesta.data.GetDocumento;
                                this.ObtenerHistorial();
                                this.MostrarResultado=true;
                                this.MostrarTabla=false;
                                this.MovimientosFiltrado = [];
                              }
                              else
                              {
                                this.MostrarResultado = false;
                                this.MostrarTabla = false;
                                this.MovimientosFiltrado = [];
                                comun.mensajeDeAlerta("No es posible consultar un documento no correspondiente de : <br/>" + this.AreaConsulta.Area.Nombre, null, null);
                              };
                              
                            break;
                        }
                    }
                    //comun.SeEstaCargandoInformacion(false);

                    })
                    .catch(excepcion => {
                        console.log(excepcion);
                        console.log("fallo por parametros");
                        comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                        comun.SeEstaCargandoInformacion(false);
                        })
                    }
      },
      VerDetalle(datos){
        this.MovimientosFiltrados= [];
        $('#navMovimientos_table').remove();
        this.Etiqueta = datos.TipoDescripsion + " " + datos.Tomo;
        switch (datos.Tipo)
        {
          case 1:
            this.MovimientosFiltrados = this.MovimientosDocumentos.filter(a=>a.VolumenId == datos.ElementoId);
            break;
          case 2:
            this.MovimientosFiltrados = this.MovimientosDocumentos.filter(a=>a.TerceriaId == datos.ElementoId);
            break;
          case 3:
            this.MovimientosFiltrados = this.MovimientosDocumentos.filter(a=>a.IncidenteId == datos.ElementoId);
            break;
        }
        if(this.MovimientosFiltrados.length>0)
        {
          this.$nextTick(()=> { PaginarTabla('Movimientos_table', 5)});
        }
      },
      ObtenerHistorialArchivatec(){
        $('#navArchivatec_table').remove();
        $('#navMovimientos_table').remove();
        this.MostrarTabla = false;
        this.MostrarArchivatec = true;
        this.$nextTick(()=> { PaginarTabla('Archivatec_table', 10)});
      },
      ObtenUbicacion(dato, notario){
        let cadena=''
        switch(parseInt(dato))
        {
          case 0:
            cadena ="En Archivo Anexo";
            break;
          case 1:
            cadena ="En Archivo de Juzgado";
            break;
          case 2:
            cadena =notario!="" ?  'En Notaría: ' +  notario : 'En Notaría' ;
            break;
          case 3:
            cadena ="En Archivo General";
            break;
          case 4:
            cadena ="Juez";
            break;
          case 5:
            cadena ="Proyectista 1";
            break;
          case 6:
            cadena ="1er Secretario de Acuerdos";
            break;
          case 7:
            cadena ="2o Secretario de Acuerdos";
            break;
          case 8:
            cadena ="Tribunal";
            break;
          case 10:
            cadena ="Actuaría";
            break;
          case 17:
            cadena ="Mecanógrafo (a) 1";
            break;
          case 18:
            cadena ="Mecanógrafo (a) 2";
            break;
          case 19:
            cadena ="Mecanógrafo (a) 3";
            break;
          case 20:
            cadena ="Mecanógrafo (a) 4";
            break;
          case 21:
            cadena ="Notificador (a)";
            break;
          case 22:
            cadena ="Copiadora";
            break;
          case 49:
            cadena ="Colegiado";
            break;
          case 50:
            cadena ="Juzgado de Distrito";
            break;
          case 51:
            cadena ="Recepción";
            break;
          case 52:
            cadena ="Ministerio Público";
            break;
          case 54:
            cadena ="Tribunal Electoral";
            break;
          case 55:
            cadena ="Tribunal de lo Contensioso";
            break;
          case 56:
            cadena ="Tribunal Federal de Justicia Fiscal y Administrativa";
            break;
          case 76:
            cadena ="3er Secretario de Acuerdos";
            break;
          case 77:
            cadena ="1er Secretario Auxiliar";
            break;
          case 78:
            cadena ="2o Secretario Auxiliar";
            break;
          case 79:
            cadena ="Magistrado (a) Presidente";
            break;
          case 80:
            cadena ="Secretario Instructor A";
            break;
          case 81:
            cadena ="Secretario Instructor B";
            break;
          case 82:
            cadena ="Actuario 1";
            break;
          case 83:
            cadena ="Actuario 2";
            break;
          case 99:
            cadena ="Proyectista 2";
            break;
          default :
            cadena="";
            break;
        }
        return cadena;
      },
      DetallesExternos(dato){
        let detalles =''
        detalles = detalles + 'Recibido por: '  + (dato.DetallesExternos.NombreReceptor!=null ? dato.DetallesExternos.NombreReceptor : '' ) + '<br>';
        
        switch (dato.AreaExterna.AreaExternaId)
        {
          case 1: 
          detalles = detalles + "Notaría No : " + (dato.DetallesExternos.Numero!=0 ? dato.DetallesExternos.Numero : '') + '<br>';
          break;
          case 2: 
          detalles = detalles + "Juzgado de Distrito No : " + (dato.DetallesExternos.Numero!=0 ? dato.DetallesExternos.Numero : '') + '<br>';
          break;
          case 4: 
          detalles = detalles + "Tribunal Colegiado no : " + (dato.DetallesExternos.Numero!=0 ? dato.DetallesExternos.Numero : '') + '<br>';
          break;
          case 5: 
          detalles = detalles + "Ministerio Público No : " + (dato.DetallesExternos.Numero!=0 ? dato.DetallesExternos.Numero : '') + '<br>';
          break;
        }
        detalles = detalles  + 'Observaciones: ' + (dato.DetallesExternos.Observaciones!=null ? dato.DetallesExternos.Observaciones : '');
        // if(dato.FechaRecepcion==null)
        // {
        //   detalles = detalles + '<br>' + 
        //   ['<a class="edita-detalles" href="javascript:void(0)" title="Edita los datos del área externa">' + 
        //   '<i class="fas fa-pen-square">  Editar Detalles </i>' +
        //   '</a>'].join("");
        // }
        return detalles;
      },
      EditarDetallesExternos (datos){
        var detExt = datos.DetallesExternos;
        var arExt = datos.AreaExterna;
        datos = null;
        this.DatosExternos.DetallesExternos = detExt;
        this.DatosExternos.AreaExterna= arExt;
        this.MostrarModal = true;
      },
      EstatusModal(evento){
        this.MostrarModal = false;
        if(evento.Estatus==true)
        {
          comun.mensajeDeAlerta("Se ha editado Correctamente.", null, null);
          this.MovimientosFiltrados[0].DetallesExternos = evento.Detalles.detallesExternos;
        }
      },
      ChecaCodigo: function(codigo){
            let _this=this;
            var Verificado= {
                Estatus: false,
                Mensaje: ""
            }
            if(this.AreaConsulta.Area.AreaId==21)//Archivo
            {
                var area = parseInt(codigo.substr(0,2));
                var TipoDoc = parseInt(codigo.substr(2,3));
                switch(codigo.length) // Verifica la Longitud del Código de Barras y determinar caracteres
                {
                case 13:
                    var estado = !isNaN(parseFloat(codigo)) && isFinite(codigo);
                    var anio = parseInt(codigo.substr(5,4));
                    
                    if (area!=42)
                    {
                        if (estado==false)
                        {
                            Verificado.Estatus = false;
                            Verificado.Mensaje = "Verificar código, deben ser caracteres numéricos"
                        }
                        else
                        {
                            Verificado.Estatus = estado;
                            Verificado.Mensaje = ""
                        }
                    }
                    if (area==42)
                    {
                        if(anio<=2020)
                        {
                            Verificado.Estatus = false;
                            Verificado.Mensaje = "Verificar código de barras, para documento del 2020 o inferiores se requiere complementar con numero romano correspondiente al área a consultar"
                                                    + "</br>I   .- Juzgado Primero de Ejecución."
                                                    + "</br>II  .- Juzgado Segundo de Ejecución."
                                                    + "</br>III .- Unidad de Gestión";
                        }
                        else
                        {
                            if (estado==false)
                            {
                                Verificado.Estatus = false;
                                Verificado.Mensaje = "Verificar código, deben ser caracteres numéricos"
                            }
                            else
                            {
                                Verificado.Estatus = estado;
                                Verificado.Mensaje = ""
                            }
                        }
                    }
                    
                    break;
                case 14:
                    if(area==42)
                    {
                        var anio = parseInt(codigo.substr(5,4));
                        var numerico14 = codigo.substr(0,13);
                        var romano14 = codigo.substr(13,1);
                        if(anio<=2020)
                        {
                            var estadoNumerico14 = !isNaN(parseFloat(numerico14)) && isFinite(numerico14);
                            var estadoRomano14 = romano14!="I" ? false: true;
                            if(estadoNumerico14==true && estadoRomano14 ==true)
                            {
                                Verificado.Estatus = estadoNumerico14;
                                Verificado.Mensaje = ""
                            }
                            else
                            {
                                if(estadoNumerico14==false && estadoRomano14 ==true)
                                {
                                Verificado.Estatus = false;
                                Verificado.Mensaje = "Verificar código, los primeros 13 digitos deben ser caracteres numéricos"
                                }
                                if(estadoNumerico14==true && estadoRomano14 ==false)
                                {
                                Verificado.Estatus = false;
                                Verificado.Mensaje = "Verificar código, numero romano no corresponde"
                                }
                            }
                        }
                        else
                        {
                        Verificado.Estatus = false;
                        Verificado.Mensaje = "Para documentos del 2021 o superiores no requiere nomenclatura con numero romano"
                        }
                    }
                    else
                    {
                        Verificado.Estatus = false;
                        Verificado.Mensaje = "Verifique el código de barras, debe contener 13 digitos numericos"
                    }
                    break;
                case 15:
                    if(area==42)
                    {
                        var anio = parseInt(codigo.substr(5,4));
                        var numerico15 = codigo.substr(0,13);
                        var romano15 = codigo.substr(13,2);
                        if(anio<=2020)
                        {
                            var estadoNumerico15 = !isNaN(parseFloat(numerico15)) && isFinite(numerico15);
                            var estadoRomano15 = romano15!="II" ? false: true;
                            if(estadoNumerico15==true && estadoRomano15 ==true)
                            {
                                Verificado.Estatus = estadoNumerico15;
                                Verificado.Mensaje = ""
                            }
                            else
                            {
                                if(estadoNumerico15==false && estadoRomano15 ==true)
                                {
                                Verificado.Estatus = false;
                                Verificado.Mensaje = "Verificar código, los primeros 13 digitos deben ser caracteres numéricos"
                                }
                                if(estadoNumerico15==true && estadoRomano15 ==false)
                                {
                                Verificado.Estatus = false;
                                Verificado.Mensaje = "Verificar código, numero romano no corresponde"
                                }
                            }
                        }
                        else
                        {
                        Verificado.Estatus = false;
                        Verificado.Mensaje = "Para documentos del 2021 o superiores no requiere nomenclatura con numero romano"
                        }
                    }
                    else
                    {
                        Verificado.Estatus = false;
                        Verificado.Mensaje = "Verifique el código de barras, debe contener 13 digitos numericos"
                    }
                    break;
                case 16:
                    if(area==42)
                    {
                        var anio = parseInt(codigo.substr(5,4));
                        var numerico16 = codigo.substr(0,13);
                        var romano16 = codigo.substr(13,3);
                        if(anio<=2020)
                        {
                            var estadoNumerico16 = !isNaN(parseFloat(numerico16)) && isFinite(numerico16);
                            var estadoRomano16 = romano16!="III" ? false: true;
                            if(estadoNumerico16==true && estadoRomano16 ==true)
                            {
                                Verificado.Estatus = estadoNumerico16;
                                Verificado.Mensaje = ""
                            }
                            else
                            {
                                if(estadoNumerico16==false && estadoRomano16 ==true)
                                {
                                Verificado.Estatus = false;
                                Verificado.Mensaje = "Verificar código, los primeros 13 digitos deben ser numericos"
                                }
                                if(estadoNumerico16==true && estadoRomano16 ==false)
                                {
                                Verificado.Estatus = false;
                                Verificado.Mensaje = "Verificar código, numero romano no corresponde"
                                }
                            }
                        }
                        else
                        {
                        Verificado.Estatus = false;
                        Verificado.Mensaje = "Para documentos del 2021 o superiores no requiere nomenclatura con numero romano"
                        }
                    }
                    else
                    {
                        Verificado.Estatus = false;
                        Verificado.Mensaje = "Verifique el código de barras, debe contener 13 digitos numericos"
                    }
                    break;
                default:
                    Verificado.Estatus = false;
                    if(codigo.length<13)
                    {
                        Verificado.Mensaje = "Verificar código de barras, debe completar los 13 digitos numericos y en su caso numero romano"
                    };
                    if(codigo.length>16)
                    {
                        Verificado.Mensaje = "Verificar código de barras, sobrepasa los 16 digitos"
                    }
                    
                    break;  
                }
            }
            if(this.AreaConsulta.Area.AreaId!=95 && this.AreaConsulta.Area.AreaId!=21) // las demas áreas a excepcion del archivo y juzgado de ejecucion de penas.
            {
                var area = parseInt(codigo.substr(0,2));
                if(this.AreaConsulta.Area.AreaArchivoId==area)
                {
                    switch(codigo.length)
                    {
                    case 13:
                        var estado = !isNaN(parseFloat(codigo)) && isFinite(codigo);
                        if (estado==false)
                        {
                        Verificado.Estatus = estado;
                        Verificado.Mensaje = "Verificar código, deben ser caracteres numéricos"
                        }
                        else
                        {
                        Verificado.Estatus = estado;
                        Verificado.Mensaje = ""
                        }
                        break;
                    default:
                        Verificado.Estatus = false;
                        if(codigo.length<13)
                        {
                            Verificado.Mensaje = "Verificar código de barras, debe completar los 13 digitos numericos"
                        };
                        if(codigo.length>13)
                        {
                            Verificado.Mensaje = "Verificar código de barras, sobrepasa los 13 digitos numericos"
                        }
                        
                        break;  
                    }
                }
                else
                {
                    Verificado.Estatus = false;
                    Verificado.Mensaje = "El área del documento a consulta no corresponde a : " + this.AreaConsulta.Area.Nombre
                }
            }
            if(this.AreaConsulta.Area.AreaId==95) // Ejecucion de penas y medidas de seguridad
            {   
                var area = parseInt(codigo.substr(0,2));
                switch(codigo.length)
                {
                case 13:
                    var estado = !isNaN(parseFloat(codigo)) && isFinite(codigo);
                    var anio = parseInt(codigo.substr(5,4));
                    if(area==42)
                    {
                        if(anio<=2020)
                        {
                        Verificado.Estatus = false;
                        Verificado.Mensaje = "Verificar código de barras, para documento del 2020 o inferiores se requiere complementar con numero romano correspondiente al área a consultar"
                                                + "</br>I   .- Juzgado Primero de Ejecución."
                                                + "</br>II  .- Juzgado Segundo de Ejecución."
                                                + "</br>III .- Unidad de Gestión";
                        }
                        else
                        {
                            if (estado==false)
                            {
                                Verificado.Estatus = false;
                                Verificado.Mensaje = "Verificar código de barras, debe ser numerico"
                            }
                            else
                            {
                                Verificado.Estatus = estado;
                                Verificado.Mensaje = ""
                            }
                        }
                    }
                    else
                    {
                        Verificado.Estatus = false;
                        Verificado.Mensaje = "El área del documento a consulta no corresponde"
                    }
                    break;
                case 14:
                    var anio = parseInt(codigo.substr(5,4));
                    var numerico14 = codigo.substr(0,13);
                    var romano14 = codigo.substr(13,1);
                    if(anio<=2020)
                    {
                    var estadoNumerico14 = !isNaN(parseFloat(numerico14)) && isFinite(numerico14);
                    var estadoRomano14 = romano14!="I" ? false: true;
                    if(estadoNumerico14==true && estadoRomano14 ==true)
                    {
                        Verificado.Estatus = estadoNumerico14;
                        Verificado.Mensaje = ""
                    }
                    else
                    {
                        if(estadoNumerico14==false && estadoRomano14 ==true)
                        {
                        Verificado.Estatus = false;
                        Verificado.Mensaje = "Verificar código, los primeros 13 digitos deben ser caracteres numéricos"
                        }
                        if(estadoNumerico14==true && estadoRomano14 ==false)
                        {
                        Verificado.Estatus = false;
                        Verificado.Mensaje = "Verificar código, numero romano no corresponde a I, II o III"
                        }
                    }
                    }
                    else
                    {
                    Verificado.Estatus = false;
                    Verificado.Mensaje = "Para documentos del 2021 o superiores no requiere numero romano"
                    }
                    break;
                case 15:
                    var anio = parseInt(codigo.substr(5,4));
                    var numerico15 = codigo.substr(0,13);
                    var romano15 = codigo.substr(13,2);
                    if(anio<=2020)
                    {
                    var estadoNumerico15 = !isNaN(parseFloat(numerico15)) && isFinite(numerico15);
                    var estadoRomano15 = romano15!="II" ? false: true;
                    if(estadoNumerico15==true && estadoRomano15 ==true)
                    {
                        Verificado.Estatus = estadoNumerico15;
                        Verificado.Mensaje = ""
                    }
                    else
                    {
                        if(estadoNumerico15==false && estadoRomano15 ==true)
                        {
                        Verificado.Estatus = false;
                        Verificado.Mensaje = "Verificar código, los primeros 13 digitos deben ser caracteres numéricos"
                        }
                        if(estadoNumerico15==true && estadoRomano15 ==false)
                        {
                        Verificado.Estatus = false;
                        Verificado.Mensaje = "Verificar código, numero romano no corresponde a I, II o III"
                        }
                    }
                    }
                    else
                    {
                    Verificado.Estatus = false;
                    Verificado.Mensaje = "Para documentos del 2021 o superiores no requiere numero romano"
                    }
                    break;
                case 16:
                    var anio = parseInt(codigo.substr(5,4));
                    var numerico16 = codigo.substr(0,13);
                    var romano16 = codigo.substr(13,3);
                    if(anio<=2020)
                    {
                    var estadoNumerico16 = !isNaN(parseFloat(numerico16)) && isFinite(numerico16);
                    var estadoRomano16 = romano16!="III" ? false: true;
                    if(estadoNumerico16==true && estadoRomano16 ==true)
                    {
                        Verificado.Estatus = estadoNumerico16;
                        Verificado.Mensaje = ""
                    }
                    else
                    {
                        if(estadoNumerico16==false && estadoRomano16 ==true)
                        {
                        Verificado.Estatus = false;
                        Verificado.Mensaje = "Verificar código, los primeros 13 digitos deben ser caracteres numéricos"
                        }
                        if(estadoNumerico16==true && estadoRomano16 ==false)
                        {
                        Verificado.Estatus = false;
                        Verificado.Mensaje = "Verificar código, numero romano no corresponde a I, II o III"
                        }
                    }
                    }
                    else
                    {
                    Verificado.Estatus = false;
                    Verificado.Mensaje = "Para documentos del 2021 o superiores no requiere numero romano"
                    }
                    break;
                default:
                    Verificado.Estatus = false;
                    if(codigo.length<13)
                    {
                        Verificado.Mensaje = "Verificar código de barras, debe completar los 13 digitos numericos y en su caso numero romano"
                    };
                    if(codigo.length>16)
                    {
                        Verificado.Mensaje = "Verificar código de barras, sobrepasa los 16 digitos"
                    }
                    
                    break;  
                }
            }
            return Verificado;
      },
      DetectarEnter: function(e){
            
            if (e.keyCode==13)
            {
                var Resultado = this.ChecaCodigo(this.Busqueda.CodigoBarras);
                if(Resultado.Estatus==true)
                {
                    this.ObtenerDocumento();
                }
                else
                {
                    comun.mensajeDeAlerta(Resultado.Mensaje, null, null);
                }
            }
      },
      ObtenerDatosOrigen: function (datos){
        let Contenido ='';
        if(datos.AreaQuePresta!=null)
        {
          if(datos.AreaQuePresta.Alias!=null)
          {
            Contenido =Contenido + '<strong>' + datos.AreaQuePresta.Alias + '</strong><br/>'
          }
          else
          {
            Contenido =Contenido + '<strong>' + datos.AreaQuePresta.Nombre + '</strong><br/>'
          }
        }
        else
        {
          if(datos.AreaExterna!=null)
          {
            Contenido =Contenido + datos.AreaExterna.Nombre + '<br/>'
          }
          else
          {
            Contenido =Contenido + '<strong>Devolución del Público</strong>' + '<br/>'
          }
        };
        if(datos.UsuarioQuienPresta!=null)
        {
          Contenido = Contenido + datos.UsuarioQuienPresta.Nombre + " " + datos.UsuarioQuienPresta.ApellidoPaterno + " " + datos.UsuarioQuienPresta.ApellidoMaterno ;
        }
        return Contenido;
      },
      ObtenerDatosDestino: function (datos){
        let Contenido ='';
        if(datos.AreaQueRecibe!=null)
        {
          
          if(datos.AreaQueRecibe.Alias!=null)
          {
            Contenido =Contenido + '<strong>' + datos.AreaQueRecibe.Alias + '</strong><br/>'
          }
          else
          {
            Contenido =Contenido + '<strong>' + datos.AreaQueRecibe.Nombre + '</strong><br/>'
          }
        }
        else
        {
          if(datos.AreaExterna!=null)
          {
            Contenido =Contenido + datos.AreaExterna.Nombre + '<br/>'
          }
          else
          {
            Contenido =Contenido + '<strong>Prestamo al Público</strong>' + '<br/>'
          }
        };
        if(datos.UsuarioQuienRecibe!=null)
        {
          Contenido = Contenido + datos.UsuarioQuienRecibe.Nombre + " " + datos.UsuarioQuienRecibe.ApellidoPaterno + " " + datos.UsuarioQuienRecibe.ApellidoMaterno ;
        }
        return Contenido;
      },
      ObservacionesParaExternos: function(datos)
      {
        let obs =''
        if(datos.AreaExterna!=null)
        {
          var detalles = this.DetallesExternos(datos);
          if(datos.AreaQuePresta==null && datos.AreaQueRecibe!=null)
          {
            obs = obs + detalles + '<br>'
          }
        }
        else
        {
          obs = obs + (datos.Observaciones!=null?datos.Observaciones:'')
        }
        return obs;
      },
      UsuariosSolicitud(solicitud)
      {
        let usuario = ''
        if(solicitud.SolicitudJuzgadoId!=null)
        {
          if(solicitud.Juzgado!=null)
          {
            usuario = solicitud.Juzgado.UsuarioIdQuienSolicita.Nombre + " " + solicitud.Juzgado.UsuarioIdQuienSolicita.ApellidoPaterno + " " + solicitud.Juzgado.UsuarioIdQuienSolicita.ApellidoMaterno;
          }
        };
        if(solicitud.SolicitudPublicaId!=null)
        {
          if(solicitud.Publica!=null)
          {
            usuario = solicitud.Publica.Nombre + " " + solicitud.Publica.ApellidoPaterno + " " + solicitud.Publica.ApellidoMaterno;
          }
        }
        return usuario;
      },
      ActualizarFecha(datos){
        if(this.FechaRegistro!='' & this.FechaRegistro!=undefined & this.FechaRegistro!=null)
        {
          let peticion = {
            "ReferenciaId": 0,
            "MovimientoId" : null,
            "InventarioDocumentoId": datos.InventarioDocumentoId,
            "FechaRegistro": this.FechaRegistro,
            "eliminaFecha" : false
          };
          comun.SeEstaCargandoInformacion(true);
          axios.post(api.conexion + api.ArchivoJudicial.ActualizarDocumento, peticion,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
          .then( respuesta => {
            if(respuesta.data.SiHayError)
            {
              comun.SeEstaCargandoInformacion(false);
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            }
            else
            {
              comun.SeEstaCargandoInformacion(false);
              this.DocumentoObtenido.FechaRegistroArchivo= moment(this.FechaRegistro).format('DD/MM/YYYY');
              comun.mensajeDeAlerta("Se Actualizó la Fecha Correctamente", null, null);
              this.FechaRegistro = "";
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            console.log("fallo por parametros");
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
          })    
        }
        else
        {
          comun.mensajeDeAlerta("Defína fecha para registro en el Archivo", null, null);
        }
      },
      EliminarMovimiento(datos){
        let peticion = {
            "ReferenciaId": 0,
            "MovimientoId" : datos.MovimientoDocumentoId,
            "InventarioDocumentoId": null,
            "FechaRegistro": null,
            "eliminaFecha" : false
          };
          comun.SeEstaCargandoInformacion(true);
          axios.post(api.conexion + api.ArchivoJudicial.ActualizarDocumento, peticion,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
          .then( respuesta => {
            if(respuesta.data.SiHayError)
            {
              comun.SeEstaCargandoInformacion(false);
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            }
            else
            {
              comun.SeEstaCargandoInformacion(false);
              comun.mensajeDeAlerta("Se Elimino el movimiento Correctamente", null, null);
              this.ObtenerDocumento();
              // var Index = this.MovimientosFiltrados.indexOf(datos);
              // this.MovimientosFiltrados.splice(Index,1);
              // var Indice = this.MovimientosDocumentos.indexOf(datos);
              // this.MovimientosDocumentos.splice(Indice,1);
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            console.log("fallo por parametros");
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
          })    
      },
      ActualizarReferencia(datos){
        let peticion = {
            "ReferenciaId": datos.DocumentoId_Referencia,
            "MovimientoId" : null,
            "InventarioDocumentoId": datos.InventarioDocumentoId,
            "FechaRegistro": null,
            "eliminaFecha" : false
          };
          comun.SeEstaCargandoInformacion(true);
          axios.post(api.conexion + api.ArchivoJudicial.ActualizarDocumento, peticion,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
          .then( respuesta => {
            if(respuesta.data.SiHayError)
            {
              comun.SeEstaCargandoInformacion(false);
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            }
            else
            {
              comun.SeEstaCargandoInformacion(false);
              comun.mensajeDeAlerta("Se Actualizó la Referencia Correctamente", null, null);
              var Index = this.MovimientosFiltrados.indexOf(datos);
              this.MovimientosFiltrados.splice(Index,1);
              var Indice = this.MovimientosDocumentos.indexOf(datos);
              this.MovimientosDocumentos.splice(Indice,1);
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            console.log("fallo por parametros");
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
          })    
      },
      EliminarFecha(datos){
          let peticion = {
            "ReferenciaId": 0,
            "MovimientoId" : null,
            "InventarioDocumentoId": datos.InventarioDocumentoId,
            "FechaRegistro": null,
            "eliminaFecha" : true
          };
          comun.SeEstaCargandoInformacion(true);
          axios.post(api.conexion + api.ArchivoJudicial.ActualizarDocumento, peticion,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
          .then( respuesta => {
            if(respuesta.data.SiHayError)
            {
              comun.SeEstaCargandoInformacion(false);
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            }
            else
            {
              comun.SeEstaCargandoInformacion(false);
              this.DocumentoObtenido.FechaRegistroArchivo=null;
              comun.mensajeDeAlerta("Se Actualizó la Fecha Correctamente", null, null);
              this.FechaRegistro = "";
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            console.log("fallo por parametros");
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
          })    
      },
      EliminarSolicitud(solicitud){
        bootbox.confirm({
          title: "Mensaje del sistema",
          message: "Desea eliminar la solicitud, se eliminara solicitud y movimientos de la misma.<br />¿Desea continuar?",
          buttons: {
          cancel: {
            label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
          },
          confirm: {
            label: '<i class="fa fa-trash"></i>&nbsp;&nbsp;Eliminar'
          }
          },
        callback: (respuestaEliminar) => {
          if (respuestaEliminar) 
          {
           let peticion = {
            "solicitud" : solicitud
          };
          comun.SeEstaCargandoInformacion(true);
          axios.post(api.conexion + api.ArchivoJudicial.EliminaSolicitudHistorico, peticion,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
          .then( respuesta => {
            if(respuesta.data.SiHayError)
            {
              comun.SeEstaCargandoInformacion(false);
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            }
            else
            {
              comun.SeEstaCargandoInformacion(false);
              this.ObtenerDocumento();
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            console.log("fallo por parametros");
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
          })    
          }
        }
      });
      },
      EliminarListado(listado){
        bootbox.confirm({
          title: "Mensaje del sistema",
          message: "Desea eliminar registro de listado.<br />¿Desea continuar?",
          buttons: {
          cancel: {
            label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
          },
          confirm: {
            label: '<i class="fa fa-trash"></i>&nbsp;&nbsp;Eliminar'
          }
          },
        callback: (respuestaEliminar) => {
          if (respuestaEliminar) 
          {
           let peticion = {
            "listado" : listado
          };
          comun.SeEstaCargandoInformacion(true);
          axios.post(api.conexion + api.ArchivoJudicial.EliminaListadoHistorico, peticion,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
          .then( respuesta => {
            if(respuesta.data.SiHayError)
            {
              comun.SeEstaCargandoInformacion(false);
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            }
            else
            {
              comun.SeEstaCargandoInformacion(false);
              this.ObtenerDocumento();
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            console.log("fallo por parametros");
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
          })    
          }
        }
      });
      },
      ObtieneDatosConSolicitudes: function(row, datos)
      {
        
        if(datos.AreaExterna!=null)
        {
          return false;
        }
        if(datos.SolicitudDocumentoId!=null)
        {
          var FiltraSolicitud= this.Solicitudes.find(a=>a.SolicitudDocumentoId==datos.SolicitudDocumentoId);
          if(FiltraSolicitud!=null && FiltraSolicitud.SolicitudPublicaId!=null)
          {
            return false
          }
        }
        if(row>0 &&(datos.AreaQuePresta.AreaId!=21 && datos.AreaQueRecibe.AreaId==21))
        {
          return false
        }
        if(row>0 &&(datos.AreaQuePresta.AreaId==21 && datos.AreaQueRecibe.AreaId!=21))
        {
          return false
        }
        return true
      },
      checkRecepcion : function(document)
      {
        document.Volumenes.forEach((element)=>{
          if(element.MovimientoVolumen!=null)
          {
            if(element.MovimientoVolumen.FechaRecepcion==null)
            {
              this.pendientesRecepcion.push({
                elemento: 'Tomo no. ' + element.NumVolumen,
                areaQuePresta : element.MovimientoVolumen.AreaQuePresta!=null ? element.MovimientoVolumen.AreaQuePresta.Nombre : (element.MovimientoVolumen.AreaExterna!=null ? element.MovimientoVolumen.AreaExterna.Nombre : ''),
                areaQueRecibe : element.MovimientoVolumen.AreaQueRecibe.Nombre,
                fechaEnvio :moment(element.MovimientoVolumen.FechaMovimiento).format("DD-MM-YYYY") 
              })
            }
          }
        })
        document.Incidentes.forEach((element)=>{
          if(element.MovimientoIncidente!=null)
          {
            if(element.MovimientoIncidente.FechaRecepcion==null)
            {
              this.pendientesRecepcion.push({
                elemento: 'Incidente no. ' + element.NumeroIncidente,
                areaQuePresta : element.MovimientoIncidente.AreaQuePresta!=null ? element.MovimientoIncidente.AreaQuePresta.Nombre : (element.MovimientoIncidente.AreaExterna!=null ? element.MovimientoIncidente.AreaExterna.Nombre : ''),
                areaQueRecibe : element.MovimientoIncidente.AreaQueRecibe.Nombre,
                fechaEnvio :moment(element.MovimientoIncidente.FechaMovimiento).format("DD-MM-YYYY") 
              })
            }
          }
        })
        document.Tercerias.forEach((element)=>{
          if(element.MovimientoTerceria!=null)
          {
            if(element.MovimientoTerceria.FechaRecepcion==null)
            {
              this.pendientesRecepcion.push({
                elemento: 'Terceria no. ' + element.NumeroTerceria,
                areaQuePresta : element.MovimientoTerceria.AreaQuePresta!=null ? element.MovimientoTerceria.AreaQuePresta.Nombre : (element.MovimientoTerceria.AreaExterna!=null ? element.MovimientoTerceria.AreaExterna.Nombre : ''),
                areaQueRecibe : element.MovimientoTerceria.AreaQueRecibe.Nombre,
                fechaEnvio :moment(element.MovimientoTerceria.FechaMovimiento).format("DD-MM-YYYY") 
              })
            }
          }
        })
        
        if(this.pendientesRecepcion.length>0)
        {
          let mensaje = '<p class="text-warning">Este documento esta pendiente de recepcion:</p>';
          let etiqueta = ''
          this.pendientesRecepcion.forEach((x)=>{
            mensaje = mensaje + '</br><p class="text-warning">' + x.elemento +  ", Origen:&nbsp" + x.areaQuePresta + ", Destino:&nbsp" + x.areaQueRecibe +  '</p>';
            etiqueta = etiqueta +  x.elemento +  ", Origen: " + x.areaQuePresta + ", destino: " + x.areaQueRecibe ;
          });
           comun.mensajeDeAlerta(mensaje, null, null)
           this.messagePendientes = etiqueta;
        }
        
      },
      getUbicacionToTable : function(volumen, incidente, terceria)
      {
        let nombreUbicacion=''
        if(volumen!=null)
        {
          if(volumen.MovimientoVolumen!=null)
          {
            if(volumen.MovimientoVolumen.FechaRecepcion!=null)
            {
              nombreUbicacion = volumen.Area.Nombre
            }
            else
            {
              if(volumen.MovimientoVolumen.AreaQuePresta!=null)
              {
                nombreUbicacion = volumen.MovimientoVolumen.AreaQuePresta.Nombre;
              }
              else{
                if(volumen.MovimientoVolumen.AreaExterna!=null)
                {
                  nombreUbicacion =volumen.MovimientoVolumen.AreaExterna.Nombre
                }
                else
                {
                  nombreUbicacion= volumen.Area.Nombre;
                }
              }
            }
          }
          else {
            nombreUbicacion= volumen.Area.Nombre;
          }
        }
        if(incidente!=null)
        {
          if(incidente.MovimientoIncidente!=null)
          {
            if(incidente.MovimientoIncidente.FechaRecepcion!=null)
            {
              nombreUbicacion = incidente.Area.Nombre
            }
            else
            {
              if(incidente.MovimientoIncidente.AreaQuePresta!=null)
              {
                nombreUbicacion = incidente.MovimientoIncidente.AreaQuePresta.Nombre;
              }
              else{
                if(incidente.MovimientoIncidente.AreaExterna!=null)
                {
                  nombreUbicacion =incidente.MovimientoIncidente.AreaExterna.Nombre
                }
                else
                {
                  nombreUbicacion= incidente.Area.Nombre;
                }
              }
            }
          }
          else {
            nombreUbicacion= incidente.Area.Nombre;
          }
        }

        if(terceria!=null)
        {
          if(terceria.MovimientoTerceria!=null)
          {
            if(terceria.MovimientoTerceria.FechaRecepcion!=null)
            {
              nombreUbicacion = terceria.Area.Nombre
            }
            else
            {
              if(terceria.MovimientoTerceria.AreaQuePresta!=null)
              {
                nombreUbicacion = terceria.MovimientoTerceria.AreaQuePresta.Nombre;
              }
              else{
                if(terceria.MovimientoTerceria.AreaExterna!=null)
                {
                  nombreUbicacion =terceria.MovimientoTerceria.AreaExterna.Nombre
                }
                else
                {
                  nombreUbicacion= terceria.Area.Nombre;
                }
              }
            }
          }
          else {
            nombreUbicacion= terceria.Area.Nombre;
          }
        }
        return nombreUbicacion;
      }
    },
    mounted(){
      this.MostrarResultado=false;
      this.AreaConsulta = this.$store.state.Login_Usuario;
      if(this.AreaConsulta.Area.AreaId==95)
        {
            comun.mensajeDeAlerta("Para la Consulta de Expedientes del Juzgado de Ejecución de Penas y Medidas de Seguridad anteriores al año 2021, debera completarse el Sufijo en Numero Romano de acuerdo a su procedencia:" 
                    + "</br>I   .- Juzgado Primero de Ejecución."
                    + "</br>II  .- Juzgado Segundo de Ejecución."
                    + "</br>III .- Unidad de Gestión"
                    + "</br>Por Codigo de Barras 42xxxXXXXxxxx + Sufijo."
                    , null, null);
        }
    }
}
</script>

<style scoped>
  input[type="text"]:read-only {
    background: #f3f3f3;
  }
  input[type="text"]:read-only:focus {
    color: #fff;
  }
  .thead-custom {
    background-color: #004746;
    color: white;
  }
  .custom-area {
    background-color: #7e7f74;
  }
  .label-black {
    color: black;
  }
  .btn-custom {
    background-color: #004746;
    color: white;
  }

</style>



// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Historicos/HistoricoMovimientos.vue